import {Cookies} from 'react-cookie';
import {
    MEDIA_TYPE_RESET,
    MEDIA_TYPE_FOCUS,
    MEDIA_TYPE_DOWNLOADED,
    MEDIA_TYPES_DOWNLOADED,
    MEDIA_TYPES_PENDING,
    MEDIA_TYPES_FAILED,
    MEDIA_TYPE_FAILED,
    MEDIA_TYPE_POSTING,
    MEDIA_TYPE_EDITING,
    MEDIA_TYPE_DELETING,
    MEDIA_TYPES_RESET,
    MEDIA_TYPE_DELETED,
    MEDIA_TYPE_PICTURE_UPLOADING,
    MEDIA_TYPE_PICTURE_FAILED,
    MEDIA_TYPE_PICTURE_UPLOADED,
    MEDIA_TYPE_PICTURE_DELETING
} from './types';
import APIService from '../../services/api'
import {handleError} from '../infos/actions'

const cookies = new Cookies();

// Action creators

export const resetMediaTypeAction = () => {
    return {type: MEDIA_TYPE_RESET};
};

export const resetMediaTypesAction = () => {
    return {type: MEDIA_TYPES_RESET};
};

export const mediaTypesPendingAction = () => {
    return {type: MEDIA_TYPES_PENDING};
};

export const mediaTypePostingAction = () => {
    return {type: MEDIA_TYPE_POSTING};
};

export const mediaTypeDeletedAction = (id) => {
    return {
        type: MEDIA_TYPE_DELETED,
        payload: id
    };
};

export const mediaTypeDeletingAction = () => {
    return {type: MEDIA_TYPE_DELETING};
};

export const mediaTypeEditingAction = () => {
    return {type: MEDIA_TYPE_EDITING};
};

export const mediaTypesDownloadedAction = (types) => {
    return {
        type: MEDIA_TYPES_DOWNLOADED,
        payload: types
    };
};

export const mediaTypeDownloadedAction = (type) => {
    return {
        type: MEDIA_TYPE_DOWNLOADED,
        payload: type
    };
};

export const mediaTypeFocusAction = (type) => {
    return {
        type: MEDIA_TYPE_FOCUS,
        payload: type
    };
};
export const uploadPictureAction = (picture) => {
    return {
        type: MEDIA_TYPE_PICTURE_UPLOADING,
        payload: picture
    };
};

export const uploadPictureFailedAction = (error) => {
    return {
        type: MEDIA_TYPE_PICTURE_FAILED,
        payload: error.message
    };
};

export const uploadPictureSucceedAction = (type) => {
    return {
        type: MEDIA_TYPE_PICTURE_UPLOADED,
        payload: type
    };
};

export const deletePictureAction = () => {
    return {
        type: MEDIA_TYPE_PICTURE_DELETING
    };
};

// Actions

export function resetMediaType() {
    return (dispatch) => {
        dispatch(resetMediaTypeAction());
    }
}

export function resetMediaTypes() {
    return function (dispatch) {
        dispatch(resetMediaTypesAction());
    }
}

export function getMediaTypes(appId) {
    return function (dispatch, getState) {
        dispatch(mediaTypesPendingAction());
        return APIService
            .getMediaTypes(appId, cookies.get('token'))
            .then(types => {
                dispatch(mediaTypesDownloadedAction(types));
            })
            .catch((error) => {
                dispatch(handleError(error, MEDIA_TYPES_FAILED))
            });
    }
}

export function fetchMediaType(appId, mediaTypeId) {
    return function (dispatch, getState) {
        let types = getState().types.content;
        let type = types.find(function (type) {
            return type.id === mediaTypeId
        });

        if (type) {
            return dispatch(mediaTypeFocusAction(type));
        } else {
            return dispatch(getMediaType(appId, mediaTypeId));
        }
    }
}

export function getMediaType(appId, mediaTypeId) {
    return function (dispatch) {
        dispatch(mediaTypesPendingAction());
        return APIService
            .getMediaType(appId, mediaTypeId, cookies.get('token'))
            .then(type => {
                dispatch(mediaTypeDownloadedAction(type));
            })
            .catch((error) => {
                dispatch(handleError(error, MEDIA_TYPE_FAILED))
            });
    }
}

export function postMediaType(appId, type) {
    return function (dispatch) {
        dispatch(mediaTypePostingAction());
        return APIService
            .postMediaType(appId, type, cookies.get('token'))
            .then(type => {
                dispatch(mediaTypeDownloadedAction(type));
            })
            .catch((error) => {
                dispatch(handleError(error, MEDIA_TYPE_FAILED))
            });
    }
}

export function putMediaType(appId, type) {
    return function (dispatch) {
        dispatch(mediaTypeEditingAction());
        return APIService
            .putMediaType(appId, type, cookies.get('token'))
            .then(type => {
                dispatch(mediaTypeDownloadedAction(type));
            })
            .catch((error) => {
                dispatch(handleError(error, MEDIA_TYPE_FAILED))
            });
    }
}

export function deleteMediaType(appId, mediaTypeId) {
    return function (dispatch) {
        dispatch(mediaTypeDeletingAction());
        return APIService
            .deleteMediaType(appId, mediaTypeId, cookies.get('token'))
            .then(() => {
                dispatch(mediaTypeDeletedAction(mediaTypeId));
            })
            .catch((error) => {
                dispatch(handleError(error, MEDIA_TYPE_FAILED))
            });
    }
}

export function postMediaTypePicture(appId, mediaTypeId, picture, onUploadProgress = null) {
    return function (dispatch) {
        dispatch(uploadPictureAction(picture));
        return APIService
            .postMediaTypePicture(appId, mediaTypeId, picture, cookies.get('token'), onUploadProgress)
            .then(type => {
                dispatch(mediaTypeDownloadedAction(type));
                dispatch(uploadPictureSucceedAction(type));
            })
            .catch((error) => {
                dispatch(handleError(error, MEDIA_TYPE_FAILED));
                dispatch(uploadPictureFailedAction(error));
            });
    }
}


export function deleteMediaTypePicture(appId, mediaTypeId) {
    return function (dispatch) {
        dispatch(deletePictureAction());
        return APIService
            .deleteMediaTypePicture(appId, mediaTypeId, cookies.get('token'))
            .then((type) => {
                dispatch(mediaTypeDownloadedAction(type));
            })
            .catch((error) => {
                dispatch(handleError(error, MEDIA_TYPE_FAILED))
            });
    }
}



// WEBPACK FOOTER //
// src/store/mediatypes/actions.js